export default __webpack_public_path__ + "images/f3123fc4c9290ac22788d27f9c28d76b.png";